module.exports = __webpack_public_path__ + "static/media/hex.9b069068.svg";